import { render, staticRenderFns } from "./chuangyi.vue?vue&type=template&id=4f2709d2&scoped=true"
import script from "./chuangyi.vue?vue&type=script&lang=js"
export * from "./chuangyi.vue?vue&type=script&lang=js"
import style0 from "./chuangyi.vue?vue&type=style&index=0&id=4f2709d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2709d2",
  null
  
)

export default component.exports